import { render } from "./ProfileSettingsKinks.vue?vue&type=template&id=bd39a7ee&ts=true"
import script from "./ProfileSettingsKinks.vue?vue&type=script&lang=ts"
export * from "./ProfileSettingsKinks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__